import React from "react";
import {Footer, Header} from "../shared";
import styled from "styled-components";
import {FOOTER_ITEMS_ACTIV, FOOTER_ITEMS_KCELL} from "../../locale/Message";
import {useLocation} from "react-router-dom";
import { Condition } from "../../ui";

const LayoutRoot = styled.div`
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		min-height: 100vh;
`

const ContentRoot = styled.section`
    max-width: 383px;
		margin: 0 auto;
    @media screen and (max-width: 640px) {
        max-width: 327px;
    }
    @media screen and (max-width: 320px) {
        max-width: 300px;
    }
`

const Layout = ({ children, lang, setLang }) => {
	const { pathname} = useLocation();

	return (
		<LayoutRoot>
			<div>
				<Header lang={lang} setLang={setLang} />
				<ContentRoot>
					{children}
				</ContentRoot>
			</div>
			<footer>
				<Condition match={!pathname?.includes('aulet')}>
					<Footer lang={lang} items={pathname?.includes('activ') ? FOOTER_ITEMS_ACTIV : FOOTER_ITEMS_KCELL}/>
				</Condition>
			</footer>
		</LayoutRoot>
	);
};

export default Layout;
